import { useDispatch } from "react-redux";
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import { Feedback } from "../../models/rating.model";
import { AxiosResponse } from "axios";
import toast from "react-hot-toast";

export class RatingService {
  private dispatch = useDispatch();

  public async getRatingData(): Promise<Feedback[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<Feedback[]> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/feedback`
      );
      return response?.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/rating`);
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}
